/* TWRD gallery zoom (Gymshark-style). The image scales inside its own tile,
   no overlay, no modal. Replaces the PhotoSwipe lightbox on product pages.
   Mouse: click zooms 2.5x at the click point, the image pans with the cursor.
   Touch: tap zooms 2x at the tap point, tap again resets. No button: the tile
   is the control (role=button, aria-pressed, Enter / Space).
   Uses the img the browser already picked from srcset, loads nothing extra. */
(function () {
  'use strict';

  var TILE = '.media-gallery__item--image';
  var TOUCH = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var SCALE = TOUCH ? 2 : 2.5, SCROLL_RESET = 80;
  var active = null, scrollAt = 0;

  function img(tile) { return tile.querySelector('.media-gallery__image'); }

  function setOrigin(tile, x, y) {
    var r = tile.getBoundingClientRect();
    var px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    var py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    img(tile).style.transformOrigin = px.toFixed(1) + '% ' + py.toFixed(1) + '%';
  }

  function setState(tile, zoomed) {
    tile.classList.toggle('is-zoomed', zoomed);
    tile.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    tile.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
  }

  function close(tile) {
    if (!tile) return;
    var el = img(tile);
    setState(tile, false);
    if (el) {
      el.classList.remove('is-panning');
      el.style.transform = '';
      el.style.transformOrigin = '';
    }
    if (active === tile) active = null;
  }

  function open(tile, x, y) {
    var el = img(tile);
    if (!el) return;
    if (active && active !== tile) close(active);
    active = tile;
    scrollAt = window.scrollY;
    el.classList.remove('is-panning');
    setOrigin(tile, x, y);
    setState(tile, true);
    el.style.transform = 'scale(' + SCALE + ')';
  }

  function toggle(tile, x, y) {
    if (tile.classList.contains('is-zoomed')) close(tile);
    else open(tile, x, y);
  }

  function bind(tile) {
    if (tile.hasAttribute('aria-pressed') || !img(tile)) return;
    tile.classList.add('twrd-zoom-tile');
    tile.setAttribute('role', 'button');
    tile.setAttribute('tabindex', '0');
    setState(tile, false);
  }

  function init() {
    var tiles = document.querySelectorAll('.media-gallery ' + TILE);
    for (var i = 0; i < tiles.length; i++) bind(tiles[i]);
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest ? e.target.closest('.twrd-zoom-tile') : null;
    if (!tile) return;
    e.preventDefault();
    toggle(tile, e.clientX, e.clientY);
  });

  if (!TOUCH) {
    document.addEventListener('mousemove', function (e) {
      if (!active || !active.contains(e.target)) return;
      img(active).classList.add('is-panning');
      setOrigin(active, e.clientX, e.clientY);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return close(active);
    var tile = e.target.closest ? e.target.closest('.twrd-zoom-tile') : null;
    if (!tile || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    var r = tile.getBoundingClientRect();
    toggle(tile, r.left + r.width / 2, r.top + r.height / 2);
  });

  window.addEventListener('scroll', function () {
    if (active && Math.abs(window.scrollY - scrollAt) > SCROLL_RESET) close(active);
  }, { passive: true });

  /* Swiper virtual slides and the variant gallery add tiles after load. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
